Ext.define('SA.view.color.Spectrum', {
    alias: 'widget.spectrum',
    extend: 'Ext.Component',


    cls: 'sa-color-window-spectrum',
    html: '<div class="sa-color-window-spectrum-dot"></div>',

    initEvents() {
        this.callParent();

        this.el.on('mousedown', this.onMouseDown, this);
    },

    onMouseDown(ev) {
        var doc = Ext.getDoc();

        this.onPick(ev);

        this.mon(doc, 'mousemove', this.onPick, this);

        this.mon(doc, 'mouseup', () => {
            this.mun(doc, 'mousemove', this.onPick, this);
        }, null, {single: true});
    },

    onPick(ev) {
        var el = this.el,
            x = ev.getX() - el.getX(),
            y = ev.getY() - el.getY(),
            constrain = Ext.Number.constrain,
            proportionHue = constrain((x - el.getFrameWidth('l') - 1) / (el.getWidth(true) - 1), 0 , 1),
            proportionLum = constrain((y - el.getFrameWidth('t') - 1) / (el.getHeight(true) - 1), 0 , 1),
            color = this.color;

        color = color.derive('h', 359 * proportionHue);
        color = color.derive('l', 1 - proportionLum);

        this.fireEvent('select:color', this, color);

        ev.preventDefault();
    },

    setColor(color) {
        var el = this.el,
            dotEl = el.down('.sa-color-window-spectrum-dot'),
            round = Math.round,
            left = round((el.getWidth(true) - 1) * color.getHue() / 359 - dotEl.getWidth() / 2),
            top = round((el.getHeight(true) - 1) * (1 - color.getLuminance()) - dotEl.getHeight() / 2);

        this.color = color;

        dotEl.setStyle('left', left + 'px');
        dotEl.setStyle('top', top + 'px');
    }
});